import React from "react";
import Tooltip from "@mui/material/Tooltip";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
 
export default function PermissionTooltip({
  children,
  title,
  description,
  placement = "bottom-start",
  show = true,
}) {
  if (!show) return children;
 
  return (
<Tooltip
      arrow
      placement={placement}
      PopperProps={{
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [-40, 0],
            },
          },
        ],
      }}
      title={
<div className="flex items-start gap-2 max-w-xs">
<WarningAmberIcon
            className="text-yellow-600 mt-0.5 shrink-0"
            fontSize="small"
          />
 
          <div className="text-sm text-gray-800">
<p className="font-medium">{title}</p>
            {description && (
<p className="mt-1 text-gray-600">{description}</p>
            )}
</div>
</div>
      }
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: "#FEF8E8",
            border: "1px solid #e5e7eb",
            boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1)",
            borderRadius: "8px",
            px: 2,
            py: 1.5,
            maxWidth: 220,
          },
        },
        arrow: {
          sx: {
            color: "#FEF8E8",
          },
        },
      }}
>
<span className="inline-block">{children}</span>
</Tooltip>
  );
}